import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import icons from 'config/icons';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from 'components/link';
import I18n from 'components/i18n';

import styles from './pagination.css';

class Pagination extends Component {
  renderLinks = () => {
    const { currentPage, links } = this.props;
    const maxDistance = 3;

    return links.map((link, idx) => {
      const pageNumber = idx + 1;
      const distance = Math.abs(pageNumber - currentPage);

      // Render first and last links
      if (
        1 === pageNumber ||
        links.length === pageNumber ||
        maxDistance > distance
      ) {
        return (
          <li
            className={classNames(styles.item, {
              [styles.currentPage]: currentPage === pageNumber,
            })}
            key={link}
          >
            <Link
              className={styles.link}
              to={link}
            ><span>{pageNumber}</span></Link>
          </li>
        );
      }

      // If the distance is equal to the max distance, render an ellipse
      if (maxDistance === distance) {
        return (
          <li
            key={pageNumber}
            className={styles.ellipse}
          >
            <span>...</span>
          </li>
        );
      }

      return false;
    });
  };

  render() {
    const { currentPage, totalPages, links } = this.props;

    return (
      <div className={styles.wrapper}>
        <Link
          className={classNames(styles.prevPage, {
            [styles.disabled]: 1 === currentPage,
          })}
          disabled={1 === currentPage}
          to={links[currentPage - 2]}
        >
          <img
            alt="Previous Page"
            src={icons.arrow}
            height="15"
            width="15"
          />
          <I18n
            field="previous"
            defaultText="Previous"
          />
        </Link>
        <ul className={styles.list}>
          {this.renderLinks()}
        </ul>
        <Link
          className={classNames(styles.nextPage, {
            [styles.disabled]: currentPage === totalPages,
          })}
          disabled={currentPage === totalPages}
          to={links[currentPage]}
        >
          <I18n
            field="next"
            defaultText="Next"
          />
          <img
            alt="Next Page"
            src={icons.arrow}
            height="15"
            width="15"
          />
        </Link>
      </div>
    );
  }
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  links: PropTypes.array.isRequired,
};

export default withStyles(styles)(Pagination);
